// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/shared/Layout";
import Dashboard from "./pages/Dashboard";
import Login from "./pages/Login";

import Categories from "./pages/Categories";
import Product from "./pages/Product";
import Banner from "./pages/Banner";
import Order from "./pages/Order";
import Coupon from "./pages/Coupon";

import { Toaster } from "react-hot-toast";
import EditProduct from "./components/Product/EditProduct";
import Logout from "./pages/Logout";
import ProtectedRoute from "./private/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";

const App = () => {
  return (
    <AuthProvider>
      <Router>
        {/* <Toaster /> */}
        <Toaster 
      position="top-right" 
      toastOptions={{
        style: {
          background: '#f2f2f2',
          color: '#000000',
        },
      }}
    />
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/logout" element={<Logout />} />
          <Route
            path="/dashboard/*"
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="category" element={<Categories />} />
            <Route path="banner" element={<Banner />} />
            <Route path="product" element={<Product />} />
            <Route path="coupon" element={<Coupon />} />
            <Route path="order" element={<Order />} />
            <Route path="productEdit/:productId" element={<EditProduct />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
};

export default App;
